module.exports = __webpack_public_path__ + "img/logo.c6d3ea34.png";